<template>
  <div>
    <v-row>
      <v-col cols="8" lg="6" offset-lg="1">
        <h4>1. 商品一括登録用フォーマット（CSV）をダウンロードして下さい。</h4>
        <div class="mt-3 ml-6">
          <v-btn
            tile
            depressed
            color="grey lighten-3"
            @click="downloadTemplate()"
          >
            商品一括登録用フォーマットを取得
            <v-icon right dark> mdi-download </v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" lg="8" offset-lg="1">
        <h4>
          2. 商品画像をまとめたzipファイルを作成してください。
        </h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="9" lg="9" offset-lg="1">
        <h4>
          3. ダウンロードしたフォーマットに、登録する商品を入力して下さい。
        </h4>
        <div class="mt-3 ml-6">
          <v-card outlined color="grey lighten-3">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  以下入力時の注意点です。
                </v-list-item-title>
                <v-list-item-title>
                  ・税込カラムには、税込の場合は1を税抜きの場合は0を入力して下さい。
                </v-list-item-title>
                <v-list-item-title>
                  ・公開カラムには、公開の場合は1を非公開の場合は0を入力して下さい。
                </v-list-item-title>
                <v-list-item-title>
                  ・IDカラムに既存の商品のIDを入力した時、そのIDの商品が更新されます。
                </v-list-item-title>
                <v-list-item-title>
                  ・更新時に空にしたカラムは現状維持となります。
                </v-list-item-title>
                <v-list-item-title>
                  ・更新時にリンクカラムや画像カラムに入力した場合、既存のリンクや画像は削除されます。
                </v-list-item-title>
                <v-list-item-title>
                  ・csvの画像カラムに入力したファイル名が、zipファイル内の画像名と一致させて下さい。
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" lg="8" offset-lg="1">
        <h4>4. それぞれのファイルをアップロードして下さい。</h4>
        <div class="mt-3 ml-6">
          <v-card outlined color="grey lighten-3" class="mb-5">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  アップロードの前に以下をご確認下さい。
                </v-list-item-title>
                <v-list-item-title>
                  ・ファイルの拡張子が「.csv」と「.zip」であること
                </v-list-item-title>
                <v-list-item-title>
                  ・記入漏れ、誤記入がないこと
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
          <template v-if="status == 'success'">
            <v-alert outlined type="success">
              登録が正常に完了しました。
            </v-alert>
          </template>
          <template v-else-if="status == 'error'">
            <ErrorsAlert :errors="errors" />
          </template>
          <v-card outlined>
            <template v-if="status == 'registering'">
              <v-progress-circular
                :size="70"
                :width="7"
                color="green"
                indeterminate
                style="display: block; margin: 40px auto"
              ></v-progress-circular>
              <p class="mb-5" style="text-align: center">
                登録しています。完了するまでお待ちください。
              </p>
            </template>
            <template v-else>
              <v-card-text>
                <v-form ref="form">
                  <v-row>
                    <v-col cols="12" lg="8">
                      <v-file-input
                        v-model="productRegistration.csvFile"
                        autofocus
                        accept=".csv"
                        required
                        :rules="[presenceValidation]"
                        label="商品CSVファイル(必須)"
                      />
                      <v-file-input
                        v-model="productRegistration.zipFile"
                        autofocus
                        accept=".zip"
                        required
                        label="商品画像zipファイル(任意)"
                      />
                    </v-col>
                    <v-col>
                      <v-btn color="primary" @click="registerProducts" style='margin-top: 80px'>
                        登録する
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </template>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import blobDownloader from '@/mixins/blob_downloader'
import axios from 'axios'
import ErrorsAlert from '@/components/commons/formParts/ErrorsAlert'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  components: {
    ErrorsAlert
  },
  props: {
    originProductRegistration: {
      type: Object,
      required: true
    },
    errors: {
      type: Array,
      required: true
    },
    status: {
      type: String,
      required: true
    }
  },
  mixins: [blobDownloader, formValidationUtils],
  computed: {
    productRegistration: {
      get () {
        return this.originProductRegistration
      },
      set (value) {
        this.$emit('update-product-registration', value)
      }
    }
  },
  methods: {
    registerProducts () {
      if (!this.$refs.form.validate()) {
        return false
      }

      this.$emit('register-products', this.originProductRegistration)
      this.clearFile()
    },
    downloadTemplate () {
      axios
        .get(`/api/product_registrations_csv`, {
          responseType: 'blob',
          params: { file_type: 'ja' }
        })
        .then(
          (response) => {
            this.downloadBlob(response)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.messages
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    },
    clearFile () {
      this.productRegistration.zipFile = null
      this.productRegistration.csvFile = null
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
